import React from 'react';
import { debounce } from "lodash";
import { Form, Dropdown, Checkbox } from 'formsy-semantic-ui-react';
import { Label, Icon, Button, Message, Modal, Header, Grid, Image, Popup } from 'semantic-ui-react';
import { singleLineText, mongoNameValidation } from '../../common/RegexValidation';
import _ from 'lodash'
import defaultImg from '../../../images/common/no_integration_in_account.png'

const textOptions = [
    // { key: 'color', text: 'Color', value: 'color' },
    // { key: 'date', text: 'Date', value: 'date' },
    { key: 'email', text: 'Email', value: 'email' },
    // { key: 'date', text: 'Month', value: 'month' },
    { key: 'number', text: 'Number', value: 'number' },
    // { key: 'password', text: 'Password', value: 'password' },
    // { key: 'range', text: 'Range', value: 'range' },
    //{ key: 'tel', text: 'Telephone', value: 'tel' },
    { key: 'text', text: 'Text', value: 'text' },
    // { key: 'time', text: 'Time', value: 'time' },
    // { key: 'url', text: 'Url', value: 'url' },
    // { key: 'week', text: 'Week', value: 'week' },
]

const typeList = [
    { key: 'boolean', text: 'Boolean', value: 'boolean' },
    { key: 'checkbox', text: 'Checkbox', value: 'checkbox' },
    { key: 'dropdown', text: 'Dropdown', value: 'dropdown' },
    { key: 'radiogroup', text: 'Radio Group', value: 'radiogroup' },
    { key: 'text', text: 'Single-line', value: 'text' },
    { key: 'comment', text: 'Multi-line', value: 'comment' },
    { key: 'image', text: 'Image', value: 'image' },
]
class TextComponent extends React.Component {
    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const { selectedItem } = this.props

        return (
            <div style={{ background: '#e5e5e5', padding: "10px", }}>
                <div className="mar_t_10">
                    <strong>Single Line Type</strong>
                    <Dropdown
                        name="inputType"
                        placeholder="Input Type"
                        value={selectedItem.inputType}
                        fluids
                        selection
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'You need to select Input Type',
                        }}
                        errorLabel={errorLabel}
                        options={textOptions}
                        onChange={(e, data) => { this.setState({ inputType: data.value }) }}
                        instantValidation
                    />
                </div>
            </div>
        )
    }
}

class ChoiceComponent extends React.Component {
    render() {
        const { selectedItem } = this.props
        const errorLabel = <div className="customErrorLabel" />;


        return (
            <div style={{ background: '#e5e5e5', padding: "10px" }}>

                <div className="mar_t_10">
                    <strong>Column Count</strong>
                    <Form.Input
                        type="number"
                        min="0"
                        required
                        name="colCount"
                        value={selectedItem.colCount}
                        placeholder="Column Count"
                        onChange={(e, data) => { this.setState({ title: data.value }) }}
                        validations={{ matchRegexp: singleLineText }}
                        errorLabel={errorLabel}

                        validationErrors={{
                            matchRegexp: 'Max limit is 128. No space allowed in starting.',
                            isDefaultRequiredValue: 'Title is required',
                        }}
                    />
                </div>
                {/* {selectedItem.type === 'dropdown' &&
                    <div className="mar_t_10">
                        <Checkbox
                            name="isMultiple"
                            label="We can choose multiple items"
                            value={selectedItem.isMultiple}
                        />
                    </div>} */}
                <div className="mar_t_10">
                    <strong>Options</strong>
                    <Form.TextArea
                        name="choices"
                        value={selectedItem.choices && selectedItem.choices.join('\n')}
                        placeholder="Add list item and press enter to add another"
                        required
                        errorLabel={<Label color="red" pointing />}
                        validationErrors={{
                            isDefaultRequiredValue: 'We need listing',
                        }}
                    />
                </div>
            </div>
        )
    }
}

class TextareaComponent extends React.Component {
    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const { selectedItem } = this.props
        return (
            <div style={{ background: '#e5e5e5', padding: "10px" }}>
                <div className="mar_t_10">
                    <strong>Lines</strong>
                    <Form.Input
                        type="number"
                        required
                        name="rowCount"
                        value={selectedItem.rowCount}
                        placeholder="Rows"
                        onChange={(e, data) => { this.setState({ rows: data.value }) }}
                        validations={{ matchRegexp: singleLineText }}
                        errorLabel={errorLabel}
                        validationErrors={{
                            matchRegexp: 'Max limit is 128. No space allowed in starting.',
                            isDefaultRequiredValue: 'Title is required',
                        }}
                    />
                </div>
            </div>
        )
    }
}

class ImageComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            imageWidth: "100px",
            imageHeight: "100px"
        }
    }
    render() {
        const { selectedItem } = this.props
        return (
            <div style={{ background: '#e5e5e5', padding: "10px" }}>
                <div className="mar_t_10">
                    <strong>Width</strong>
                    <Form.Input
                        type="number"
                        name="imageWidth"
                        value={selectedItem.imageWidth}
                        placeholder="imageWidth"
                        onChange={(e, data) => { this.setState({ imageWidth: data.value }) }}
                    />
                </div>
                <div className="mar_t_10">
                    <strong>Height</strong>
                    <Form.Input
                        type="number"
                        name="imageHeight"
                        value={selectedItem.imageHeight}
                        placeholder="imageHeight"
                        onChange={(e, data) => { this.setState({ imageHeight: data.value }) }}
                    />
                </div>
                <div className="mar_t_10" >
                    <strong>Image Link</strong>
                    <div style={{
                        width: "100%",
                        overflow: "auto",
                        height: "100px"
                    }}>
                        <Image
                            src={defaultImg}
                            style={{
                                width: this.state.imageWidth + "px",
                                minWidth: this.state.imageWidth + "px",
                                height: this.state.imageHeight + "px"
                            }}
                        />
                    </div>
                    <Form.Input
                        className="display-none"
                        type="text"
                        name="imageLink"
                        value={defaultImg}
                        placeholder="imageLink"
                        onChange={(e, data) => { this.setState({ imageLink: data.value }) }}
                    />
                </div>
            </div>
        )
    }
}


class SchemaModalForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isUpdate: props.selectedItem ? true : false,
            isValidForm: false,
            schema: props.schema ? props.schema : [],
            selectedItem: props.selectedItem ? props.selectedItem : {},
            addAgain: false
        }
    }


    convertToArray = (choices) => {
        if (choices) {
            var arr = choices.split('\n');
            var choiceArr = []
            for (var i = 0; i < arr.length; i++) {
                /\s$/.test(arr[i]) ? arr[i] = arr[i].replace(/\s$/, '') : null;
                if (arr[i].length !== 0) {
                    choiceArr.push(arr[i])
                }
            }
        }

        let uniq = [...new Set(choiceArr)]
        return uniq
    }

    validateItem = (formData) => {
        formData.validators = []
        let obj = {}
        if (formData.minValue) {
            obj.minValue = formData.minValue
        }
        if (formData.maxValue) {
            obj.maxValue = formData.maxValue
        }
        if (formData.validatorType) {
            obj.type = formData.validatorType
        }
        formData.validators.push(obj)
        //delete formData.isValidation
        delete formData.minValue
        delete formData.maxValue
        delete formData.validatorType
    }
    handleChange = (e, data) => {
        let nameCheck = this.state.schema.some(f => f.name === data.value);
        if (nameCheck) {
            this.setState({ alreadyExist: true })
        }
        else{
            this.setState({ title: data.value });
            this.updateNameField(data.value);
            if(this.state.alreadyExist){
                this.setState({ alreadyExist: false });
            }
        }
    }

    handleSubmit = (formData) => {
        console.log(formData)
        delete formData.addNew
        console.log(formData)
        if (this.state.isUpdate) {
            // update Item
            this.UpdateItem(formData)
        } else {
            //check already exist in schema listss
            let nameCheck = this.state.schema.some(f => f.name === formData.name);
            if (nameCheck) {
                this.setState({ alreadyExist: true })
            }
            else {
                formData.metaData = {}
                //create new item in schema
                this.createItem(formData)
            }
        }
    }

    UpdateItem = (formData) => {
        // this.validateItem(formData)
        var findIndex = this.state.schema.findIndex(x => x.name == formData.name);
        this.state.schema.slice(0, findIndex);
        if (formData.choices) {
            formData.choices = this.convertToArray(formData.choices);
        }

        this.state.schema[findIndex] = formData;
        this.setState({ schema: this.state.schema })
        this.submitSchema()
    }

    createItem = (formData) => {
        // this.validateItem(formData)
        if (formData.choices) {
            formData.choices = this.convertToArray(formData.choices);
        }
        this.setState({ schema: [...this.state.schema, formData] })
        this.submitSchema()
    }

    submitSchema = debounce(async () => {
        this.props.onSubmitSchema(this.state.schema)
        console.log("this.state.addAgain ",this.state.addAgain);
        if (!this.state.addAgain) {
            this.props.schemaOpen(false)
        }

        this.setState({ addAgain: true })
        if (document.getElementById("schemaForm")) {
            document.getElementById("schemaForm").reset()
        }


    }, 100);



    close = () => {
        this.setState({ alreadyExist: false, isUpdate: false })
        document.getElementById("schemaForm").reset()
        this.props.schemaOpen(false)
    }


    updateNameField = (name) => {
        console.log("this.state.isUpdate ",this.state.isUpdate);
        if (!this.state.isUpdate) {
            this.setState(prevState => {
                let selectedItem = Object.assign({}, prevState.selectedItem);
                // let abc = name.replace(/\d/g, '')
                selectedItem.name = _.camelCase(name) // Changes made for KLM-9053
                return { selectedItem };
            })
        }

    }

    render() {
        const { selectedItem } = this.state
        console.log("🚀 ~ file: SchemaModalForm.jsx:338 ~ SchemaModalForm ~ render ~ selectedItem:", selectedItem)
        const errorLabel = <div className="customErrorLabel" />;


        const DuplicateCheck = this.state.alreadyExist &&
            <Message icon color='yellow'>
                <Icon name='warning sign' />
                <Message.Content>
                    <Message.Header>Duplicate</Message.Header>
                    Entry already exist!
                </Message.Content>
            </Message>

        return (
            <Modal
                className="basicModal"
                open={this.props.open}
                size='small'
                onClose={this.close}
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Header content="Add Custom Attribute" />
                <React.Fragment>
                    <Form noValidate
                        id="schemaForm"
                        className="formcyForm schemaForm"
                        ref={ref => this.form = ref}
                        onValidSubmit={this.handleSubmit}
                        onValid={(e) => this.setState({ isValidForm: true })}
                        onInvalid={(e) => this.setState({ isValidForm: false })}
                    >
                        <Modal.Content className="w_100 pad_20" scrolling>
                            {DuplicateCheck}
                            <Grid>
                                <Grid.Row columns="equal">
                                    <Grid.Column style={{ paddingLeft: "0" }}>
                                        <div>
                                            <strong>Title <span className="clr-red">*</span></strong>
                                            <Form.Input
                                                icon="text height"
                                                iconPosition="left"
                                                required
                                                name="title"
                                                value={selectedItem.title}
                                                placeholder="Title"
                                                onChange={this.handleChange}
                                                validations={{ matchRegexp: singleLineText }}
                                                errorLabel={errorLabel}

                                                validationErrors={{
                                                    matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                    isDefaultRequiredValue: 'Title is required',
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <strong>Placeholder Text</strong>
                                            <Form.Input
                                                icon="text cursor"
                                                iconPosition="left"
                                                name="placeholder"
                                                value={selectedItem.placeholder}
                                                placeholder="Placeholder Text"
                                                onChange={(e, data) => {
                                                    this.setState({ placeholder: data.value })

                                                }}
                                                validations={{ matchRegexp: singleLineText }}
                                                errorLabel={errorLabel}

                                                validationErrors={{
                                                    matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                    isDefaultRequiredValue: 'Placeholders is required',
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <strong>Description</strong>
                                            <Form.TextArea

                                                name="detail"
                                                value={selectedItem.detail}
                                                placeholder="Custom attribute detail"
                                            />
                                        </div>

                                        <div className="display-block float-left w_100" style={{ margin: "0 10px 0 0" }}>
                                            <Checkbox
                                                name="isRequired"
                                                label="This is a mandatory custom attribute."
                                                value={selectedItem.isRequired}
                                            />
                                        </div>
                                        <div className="display-block float-left w_100" style={{ margin: "0 10px 0 0" }}>
                                            <Checkbox
                                                name="isRestricted"
                                                label="This is a restricted field (Management Only)"
                                                value={selectedItem.isRestricted}
                                            />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column style={{ paddingRight: "0" }}>
                                        <div>
                                            <strong>Name Field
                                                <span className="clr-red">*</span>
                                                <Popup
                                                    position="bottom right"
                                                    className="popupStyled"
                                                    inverted
                                                    trigger={<Icon name="info circle" className="float-right" />}
                                                    content='Name field is auto generated with title string. Its camel case and not contain any symbol and number.'
                                                />
                                            </strong>
                                            <Form.Input
                                                icon="database"
                                                iconPosition="left"
                                                readOnly
                                                name="name"
                                                value={selectedItem.name}
                                                placeholder="Name"
                                                style={{
                                                    opacity: ".4"
                                                }}
                                            />
                                        </div>

                                        <div className="">
                                            <strong>Type</strong>
                                            <Dropdown
                                                pointing="top"
                                                name="type"
                                                placeholder="Type"
                                                value={selectedItem.type}
                                                fluid
                                                selection
                                                required
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'You need to select Type',
                                                }}

                                                errorLabel={errorLabel}
                                                options={typeList}
                                                onChange={(e, data) => {
                                                    this.setState(prevState => {
                                                        let selectedItem = Object.assign({}, prevState.selectedItem);
                                                        selectedItem.type = data.value;
                                                        return { selectedItem };
                                                    })
                                                }}
                                                instantValidation
                                            />
                                        </div>
                                        <div >
                                            {selectedItem.type === 'text' && <TextComponent {...this.state} />}
                                            {selectedItem.type === 'radiogroup' && <ChoiceComponent {...this.state} />}
                                            {selectedItem.type === 'checkbox' && <ChoiceComponent {...this.state} />}
                                            {selectedItem.type === 'dropdown' && <ChoiceComponent {...this.state} />}
                                            {selectedItem.type === 'comment' && <TextareaComponent {...this.state} />}
                                            {selectedItem.type === 'image' && <ImageComponent {...this.state} />}
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy pad_20">
                            {this.state.isUpdate ? null :
                                <div style={{ float: "left" }}>
                                    <Checkbox
                                        name="addNew"
                                        label="Add New attribute"
                                        value={this.state.addAgain}
                                        defaultChecked={this.state.addAgain}
                                        onChange={(e, data) => { this.setState({ addAgain: data.checked }) }}
                                    />
                                </div>}

                            <Button
                                className="button-submit "
                                type="submit"
                                disabled={!this.state.isValidForm}>
                                {this.state.isUpdate ? "Update" : "Add"}
                            </Button>
                            <Button
                                className="button-cancel "
                                id='cancelSchema'
                                onClick={this.close}>
                                Cancel
                            </Button>
                        </Modal.Actions>
                    </Form>
                </React.Fragment>
            </Modal>
        );
    }
}

export default SchemaModalForm;



// class CheckboxComponent extends React.Component {
//     render() {
//         const errorLabel = <div className="customErrorLabel" />;
//         const { selectedItem } = this.props
//         return (
//             <div style={{ background: '#e5e5e5', padding: "10px" }}>
//                 <div className="mar_t_10">
//                     <Checkbox
//                         name="hasNone"
//                         label="Is None required"
//                         defaultChecked={true}
//                         value={true}
//                     />
//                 </div>
//                 <div className="mar_t_10">
//                     <strong>Column Count</strong>
//                     <Form.Input
//                         type="number"
//                         required
//                         name="colCount"
//                         value={selectedItem.colCount}
//                         placeholder="Column Count"
//                         onChange={(e, data) => { this.setState({ title: data.value }) }}
//                         validations={{ matchRegexp: singleLineText }}
//                         errorLabel={errorLabel}
//                         validationErrors={{
//                             matchRegexp: 'Max limit is 128. No space allowed in starting.',
//                             isDefaultRequiredValue: 'Title is required',
//                         }}
//                     />
//                 </div>
//                 <div className="mar_t_10">
//                     <strong>Choices</strong>
//                     <Form.TextArea
//                         name="choices"
//                         value={selectedItem.choices && selectedItem.choices.join('\n')}
//                         placeholder="Choices list"
//                         required
//                         errorLabel={<Label color="red" pointing />}
//                         validationErrors={{
//                             isDefaultRequiredValue: 'We need listing',
//                         }}
//                     />
//                 </div>
//             </div>
//         )
//     }
// }